import type { JSX, Ref } from 'react'

import { DividerColors, DividerFluid } from './Divider.h'
import { DividerLine } from './Divider.styled'

export interface IDividerProps {
  ref?: Ref<HTMLDivElement>
  background?: DividerColors
  fluid?: DividerFluid
  width?: string
  height?: string
  className?: string
}

export function Divider({
  ref,
  background = DividerColors.TEXT_ICON_SECONDARY,
  fluid = DividerFluid.Horizontal,
  width,
  height,
  className,
}: IDividerProps): JSX.Element {
  return (
    <DividerLine
      ref={ref}
      width={width}
      height={height}
      background={background}
      fluid={fluid}
      className={className}
    />
  )
}
